"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bold = {
    0x20: [0, 0, .25],
    0x21: [.705, 0, .35],
    0x22: [.694, -0.329, .603],
    0x23: [.694, .193, .958],
    0x24: [.75, .056, .575],
    0x25: [.75, .056, .958],
    0x26: [.705, .011, .894],
    0x27: [.694, -0.329, .319],
    0x28: [.75, .249, .447],
    0x29: [.75, .249, .447],
    0x2A: [.75, -0.306, .575],
    0x2B: [.633, .131, .894],
    0x2C: [.171, .194, .319],
    0x2D: [.278, -0.166, .383],
    0x2E: [.171, 0, .319],
    0x2F: [.75, .25, .575],
    0x30: [.654, .01, .575],
    0x31: [.655, 0, .575],
    0x32: [.654, 0, .575],
    0x33: [.655, .011, .575],
    0x34: [.656, 0, .575],
    0x35: [.655, .011, .575],
    0x36: [.655, .011, .575],
    0x37: [.676, .011, .575],
    0x38: [.654, .011, .575],
    0x39: [.654, .011, .575],
    0x3A: [.444, 0, .319],
    0x3B: [.444, .194, .319],
    0x3C: [.587, .085, .894],
    0x3D: [.393, -0.109, .894],
    0x3E: [.587, .085, .894],
    0x3F: [.7, 0, .543],
    0x40: [.699, .006, .894],
    0x41: [.698, 0, .869],
    0x42: [.686, 0, .818],
    0x43: [.697, .011, .831],
    0x44: [.686, 0, .882],
    0x45: [.68, 0, .756],
    0x46: [.68, 0, .724],
    0x47: [.697, .01, .904],
    0x48: [.686, 0, .9],
    0x49: [.686, 0, .436],
    0x4A: [.686, .011, .594],
    0x4B: [.686, 0, .901],
    0x4C: [.686, 0, .692],
    0x4D: [.686, 0, 1.092],
    0x4E: [.686, 0, .9],
    0x4F: [.696, .01, .864],
    0x50: [.686, 0, .786],
    0x51: [.696, .193, .864],
    0x52: [.686, .011, .862],
    0x53: [.697, .011, .639],
    0x54: [.675, 0, .8],
    0x55: [.686, .011, .885],
    0x56: [.686, .007, .869],
    0x57: [.686, .007, 1.189],
    0x58: [.686, 0, .869],
    0x59: [.686, 0, .869],
    0x5A: [.686, 0, .703],
    0x5B: [.75, .25, .319],
    0x5C: [.75, .25, .575],
    0x5D: [.75, .25, .319],
    0x5E: [.694, -0.52, .575],
    0x5F: [-0.01, .061, .575],
    0x60: [.706, -0.503, .575],
    0x61: [.453, .006, .559],
    0x62: [.694, .006, .639],
    0x63: [.453, .006, .511],
    0x64: [.694, .006, .639],
    0x65: [.452, .006, .527],
    0x66: [.7, 0, .351, { ic: .101 }],
    0x67: [.455, .201, .575],
    0x68: [.694, 0, .639],
    0x69: [.695, 0, .319],
    0x6A: [.695, .2, .351],
    0x6B: [.694, 0, .607],
    0x6C: [.694, 0, .319],
    0x6D: [.45, 0, .958],
    0x6E: [.45, 0, .639],
    0x6F: [.452, .005, .575],
    0x70: [.45, .194, .639],
    0x71: [.45, .194, .607],
    0x72: [.45, 0, .474],
    0x73: [.453, .006, .454],
    0x74: [.635, .005, .447],
    0x75: [.45, .006, .639],
    0x76: [.444, 0, .607],
    0x77: [.444, 0, .831],
    0x78: [.444, 0, .607],
    0x79: [.444, .2, .607],
    0x7A: [.444, 0, .511],
    0x7B: [.75, .25, .575],
    0x7C: [.75, .249, .319],
    0x7D: [.75, .25, .575],
    0x7E: [.344, -0.202, .575],
    0xA0: [0, 0, .25],
    0xA8: [.695, -0.535, .575],
    0xAC: [.371, -0.061, .767],
    0xAF: [.607, -0.54, .575],
    0xB0: [.702, -0.536, .575],
    0xB1: [.728, .035, .894],
    0xB4: [.706, -0.503, .575],
    0xB7: [.336, -0.166, .319],
    0xD7: [.53, .028, .894],
    0xF7: [.597, .096, .894],
    0x131: [.452, .008, .394, { sk: .0319 }],
    0x237: [.451, .201, .439, { sk: .0958 }],
    0x2B9: [.563, -0.033, .344],
    0x2C6: [.694, -0.52, .575],
    0x2C7: [.66, -0.515, .575],
    0x2C9: [.607, -0.54, .575],
    0x2CA: [.706, -0.503, .575],
    0x2CB: [.706, -0.503, .575],
    0x2D8: [.694, -0.5, .575],
    0x2D9: [.695, -0.525, .575],
    0x2DA: [.702, -0.536, .575],
    0x2DC: [.694, -0.552, .575],
    0x300: [.706, -0.503, 0],
    0x301: [.706, -0.503, 0],
    0x302: [.694, -0.52, 0],
    0x303: [.694, -0.552, 0],
    0x304: [.607, -0.54, 0],
    0x306: [.694, -0.5, 0],
    0x307: [.695, -0.525, 0],
    0x308: [.695, -0.535, 0],
    0x30A: [.702, -0.536, 0],
    0x30B: [.714, -0.511, 0],
    0x30C: [.66, -0.515, 0],
    0x338: [.711, .21, 0],
    0x391: [.698, 0, .869],
    0x392: [.686, 0, .818],
    0x393: [.68, 0, .692],
    0x394: [.698, 0, .958],
    0x395: [.68, 0, .756],
    0x396: [.686, 0, .703],
    0x397: [.686, 0, .9],
    0x398: [.696, .01, .894],
    0x399: [.686, 0, .436],
    0x39A: [.686, 0, .901],
    0x39B: [.698, 0, .806],
    0x39C: [.686, 0, 1.092],
    0x39D: [.686, 0, .9],
    0x39E: [.675, 0, .767],
    0x39F: [.696, .01, .864],
    0x3A0: [.68, 0, .9],
    0x3A1: [.686, 0, .786],
    0x3A2: [.696, .01, .894],
    0x3A3: [.686, 0, .831],
    0x3A4: [.675, 0, .8],
    0x3A5: [.697, 0, .894],
    0x3A6: [.686, 0, .831],
    0x3A7: [.686, 0, .869],
    0x3A8: [.686, 0, .894],
    0x3A9: [.696, 0, .831],
    0x3B1: [.452, .008, .761, { sk: .0319 }],
    0x3B2: [.701, .194, .66, { sk: .0958 }],
    0x3B3: [.451, .211, .59, { ic: .027 }],
    0x3B4: [.725, .008, .522, { sk: .0639 }],
    0x3B5: [.461, .017, .529, { sk: .0958 }],
    0x3B6: [.711, .202, .508, { ic: .013, sk: .0958 }],
    0x3B7: [.452, .211, .6, { sk: .0639 }],
    0x3B8: [.702, .008, .562, { sk: .0958 }],
    0x3B9: [.452, .008, .412, { sk: .0639 }],
    0x3BA: [.452, .008, .668],
    0x3BB: [.694, .013, .671],
    0x3BC: [.452, .211, .708, { sk: .0319 }],
    0x3BD: [.452, 0, .577, { ic: .031, sk: .0319 }],
    0x3BE: [.711, .201, .508, { sk: .128 }],
    0x3BF: [.452, .008, .585, { sk: .0639 }],
    0x3C0: [.444, .008, .682],
    0x3C1: [.451, .211, .612, { sk: .0958 }],
    0x3C2: [.451, .105, .424, { ic: .033, sk: .0958 }],
    0x3C3: [.444, .008, .686],
    0x3C4: [.444, .013, .521, { ic: .089, sk: .0319 }],
    0x3C5: [.453, .008, .631, { sk: .0319 }],
    0x3C6: [.452, .216, .747, { sk: .0958 }],
    0x3C7: [.452, .201, .718, { sk: .0639 }],
    0x3C8: [.694, .202, .758, { sk: .128 }],
    0x3C9: [.453, .008, .718],
    0x3D1: [.701, .008, .692, { sk: .0958 }],
    0x3D2: [.697, 0, .894],
    0x3D5: [.694, .202, .712, { sk: .0958 }],
    0x3D6: [.444, .008, .975],
    0x3DC: [.68, 0, .724],
    0x3F1: [.451, .194, .612, { sk: .0958 }],
    0x3F5: [.444, .007, .483, { sk: .0639 }],
    0x2002: [0, 0, .5],
    0x2003: [0, 0, .999],
    0x2004: [0, 0, .333],
    0x2005: [0, 0, .25],
    0x2006: [0, 0, .167],
    0x2009: [0, 0, .167],
    0x200A: [0, 0, .083],
    0x2013: [.3, -0.249, .575],
    0x2014: [.3, -0.249, 1.15],
    0x2015: [.3, -0.249, 1.15],
    0x2016: [.75, .248, .575],
    0x2017: [-0.01, .061, .575],
    0x2018: [.694, -0.329, .319],
    0x2019: [.694, -0.329, .319],
    0x201C: [.694, -0.329, .603],
    0x201D: [.694, -0.329, .603],
    0x2020: [.702, .211, .511],
    0x2021: [.702, .202, .511],
    0x2022: [.474, -0.028, .575],
    0x2026: [.171, 0, 1.295],
    0x2032: [.563, -0.033, .344],
    0x2033: [.563, 0, .688],
    0x2034: [.563, 0, 1.032],
    0x203E: [.607, -0.54, .575],
    0x2044: [.75, .25, .575],
    0x2057: [.563, 0, 1.376],
    0x20D7: [.723, -0.513, .575],
    0x210F: [.694, .008, .668, { sk: -0.0319 }],
    0x2111: [.686, .026, .554],
    0x2113: [.702, .019, .474, { sk: .128 }],
    0x2118: [.461, .21, .74],
    0x211C: [.686, .026, .828],
    0x2135: [.694, 0, .703],
    0x2190: [.518, .017, 1.15],
    0x2191: [.694, .193, .575],
    0x2192: [.518, .017, 1.15],
    0x2193: [.694, .194, .575],
    0x2194: [.518, .017, 1.15],
    0x2195: [.767, .267, .575],
    0x2196: [.724, .194, 1.15],
    0x2197: [.724, .193, 1.15],
    0x2198: [.694, .224, 1.15],
    0x2199: [.694, .224, 1.15],
    0x219A: [.711, .21, 1.15],
    0x219B: [.711, .21, 1.15],
    0x21A6: [.518, .017, 1.15],
    0x21A9: [.518, .017, 1.282],
    0x21AA: [.518, .017, 1.282],
    0x21AE: [.711, .21, 1.15],
    0x21BC: [.518, -0.22, 1.15],
    0x21BD: [.281, .017, 1.15],
    0x21C0: [.518, -0.22, 1.15],
    0x21C1: [.281, .017, 1.15],
    0x21CC: [.718, .017, 1.15],
    0x21CD: [.711, .21, 1.15],
    0x21CE: [.711, .21, 1.15],
    0x21CF: [.711, .21, 1.15],
    0x21D0: [.547, .046, 1.15],
    0x21D1: [.694, .193, .703],
    0x21D2: [.547, .046, 1.15],
    0x21D3: [.694, .194, .703],
    0x21D4: [.547, .046, 1.15],
    0x21D5: [.767, .267, .703],
    0x2200: [.694, .016, .639],
    0x2202: [.71, .017, .628, { ic: .029, sk: .0958 }],
    0x2203: [.694, 0, .639],
    0x2204: [.711, .21, .639],
    0x2205: [.767, .073, .575],
    0x2206: [.698, 0, .958],
    0x2207: [.686, .024, .958],
    0x2208: [.587, .086, .767],
    0x2209: [.711, .21, .767],
    0x220B: [.587, .086, .767],
    0x220C: [.711, .21, .767],
    0x2212: [.281, -0.221, .894],
    0x2213: [.537, .227, .894],
    0x2215: [.75, .25, .575],
    0x2216: [.75, .25, .575],
    0x2217: [.472, -0.028, .575],
    0x2218: [.474, -0.028, .575],
    0x2219: [.474, -0.028, .575],
    0x221A: [.82, .18, .958, { ic: .03 }],
    0x221D: [.451, .008, .894],
    0x221E: [.452, .008, 1.15],
    0x2220: [.714, 0, .722],
    0x2223: [.75, .249, .319],
    0x2224: [.75, .249, .319],
    0x2225: [.75, .248, .575],
    0x2226: [.75, .248, .575],
    0x2227: [.604, .017, .767],
    0x2228: [.604, .016, .767],
    0x2229: [.603, .016, .767],
    0x222A: [.604, .016, .767],
    0x222B: [.711, .211, .569, { ic: .063 }],
    0x223C: [.391, -0.109, .894],
    0x2240: [.583, .082, .319],
    0x2241: [.711, .21, .894],
    0x2243: [.502, 0, .894],
    0x2244: [.711, .21, .894],
    0x2245: [.638, .027, .894],
    0x2247: [.711, .21, .894],
    0x2248: [.524, -0.032, .894],
    0x2249: [.711, .21, .894],
    0x224D: [.533, .032, .894],
    0x2250: [.721, -0.109, .894],
    0x2260: [.711, .21, .894],
    0x2261: [.505, 0, .894],
    0x2262: [.711, .21, .894],
    0x2264: [.697, .199, .894],
    0x2265: [.697, .199, .894],
    0x226A: [.617, .116, 1.15],
    0x226B: [.618, .116, 1.15],
    0x226D: [.711, .21, .894],
    0x226E: [.711, .21, .894],
    0x226F: [.711, .21, .894],
    0x2270: [.711, .21, .894],
    0x2271: [.711, .21, .894],
    0x227A: [.585, .086, .894],
    0x227B: [.586, .086, .894],
    0x2280: [.711, .21, .894],
    0x2281: [.711, .21, .894],
    0x2282: [.587, .085, .894],
    0x2283: [.587, .086, .894],
    0x2284: [.711, .21, .894],
    0x2285: [.711, .21, .894],
    0x2286: [.697, .199, .894],
    0x2287: [.697, .199, .894],
    0x2288: [.711, .21, .894],
    0x2289: [.711, .21, .894],
    0x228E: [.604, .016, .767],
    0x2291: [.697, .199, .894],
    0x2292: [.697, .199, .894],
    0x2293: [.604, 0, .767],
    0x2294: [.604, 0, .767],
    0x2295: [.632, .132, .894],
    0x2296: [.632, .132, .894],
    0x2297: [.632, .132, .894],
    0x2298: [.632, .132, .894],
    0x2299: [.632, .132, .894],
    0x22A2: [.693, 0, .703],
    0x22A3: [.693, 0, .703],
    0x22A4: [.694, 0, .894],
    0x22A5: [.693, 0, .894],
    0x22A8: [.75, .249, .974],
    0x22AC: [.711, .21, .703],
    0x22AD: [.75, .249, .974],
    0x22C4: [.523, .021, .575],
    0x22C5: [.336, -0.166, .319],
    0x22C6: [.502, 0, .575],
    0x22C8: [.54, .039, 1],
    0x22E2: [.711, .21, .894],
    0x22E3: [.711, .21, .894],
    0x22EE: [.951, .029, .319],
    0x22EF: [.336, -0.166, 1.295],
    0x22F1: [.871, -0.101, 1.323],
    0x2308: [.75, .248, .511],
    0x2309: [.75, .248, .511],
    0x230A: [.749, .248, .511],
    0x230B: [.749, .248, .511],
    0x2322: [.405, -0.108, 1.15],
    0x2323: [.392, -0.126, 1.15],
    0x2329: [.75, .249, .447],
    0x232A: [.75, .249, .447],
    0x25B3: [.711, 0, 1.022],
    0x25B5: [.711, 0, 1.022],
    0x25B9: [.54, .039, .575],
    0x25BD: [.5, .21, 1.022],
    0x25BF: [.5, .21, 1.022],
    0x25C3: [.539, .038, .575],
    0x25EF: [.711, .211, 1.15],
    0x2660: [.719, .129, .894],
    0x2661: [.711, .024, .894],
    0x2662: [.719, .154, .894],
    0x2663: [.719, .129, .894],
    0x266D: [.75, .017, .447],
    0x266E: [.741, .223, .447],
    0x266F: [.724, .224, .447],
    0x2758: [.75, .249, .319],
    0x27E8: [.75, .249, .447],
    0x27E9: [.75, .249, .447],
    0x27F5: [.518, .017, 1.805],
    0x27F6: [.518, .017, 1.833],
    0x27F7: [.518, .017, 2.126],
    0x27F8: [.547, .046, 1.868],
    0x27F9: [.547, .046, 1.87],
    0x27FA: [.547, .046, 2.126],
    0x27FC: [.518, .017, 1.833],
    0x29F8: [.711, .21, .894],
    0x2A2F: [.53, .028, .894],
    0x2A3F: [.686, 0, .9],
    0x2AAF: [.696, .199, .894],
    0x2AB0: [.697, .199, .894],
    0x3008: [.75, .249, .447],
    0x3009: [.75, .249, .447],
};
//# sourceMappingURL=bold.js.map